"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getThisMonthRange = exports.getThisWeekRange = exports.getTodayRange = exports.getCurrentYearRange = exports.getCurrentQuarterRange = exports.getLastMonthRange = void 0;
const getLastMonthRange = () => {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const end = new Date(now.getFullYear(), now.getMonth(), 0);
    return [start, end];
};
exports.getLastMonthRange = getLastMonthRange;
const getCurrentQuarterRange = () => {
    const now = new Date();
    const quarter = Math.floor(now.getMonth() / 3);
    const start = new Date(now.getFullYear(), quarter * 3, 1);
    const end = new Date(now.getFullYear(), quarter * 3 + 3, 0);
    return [start, end];
};
exports.getCurrentQuarterRange = getCurrentQuarterRange;
const getCurrentYearRange = () => {
    const now = new Date();
    const start = new Date(now.getFullYear(), 0, 1);
    const end = new Date(now.getFullYear(), 11, 31);
    return [start, end];
};
exports.getCurrentYearRange = getCurrentYearRange;
const getTodayRange = () => {
    const start = new Date();
    start.setHours(0, 0, 0, 0);
    const end = new Date();
    end.setHours(23, 59, 59, 999);
    return [start, end];
};
exports.getTodayRange = getTodayRange;
const getThisWeekRange = () => {
    const today = new Date();
    const day = today.getDay();
    const diffToMonday = (day === 0 ? -6 : 1) - day;
    const start = new Date(today);
    start.setDate(today.getDate() + diffToMonday);
    start.setHours(0, 0, 0, 0);
    const end = new Date(start);
    end.setDate(start.getDate() + 6);
    end.setHours(23, 59, 59, 999);
    return [start, end];
};
exports.getThisWeekRange = getThisWeekRange;
const getThisMonthRange = () => {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), 1);
    start.setHours(0, 0, 0, 0);
    const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    end.setHours(23, 59, 59, 999);
    return [start, end];
};
exports.getThisMonthRange = getThisMonthRange;
